import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';

export default function Company() {
  return (
    <section
      id="company"
      data-testid="company-section"
      className="relative py-28 md:py-36 px-5 md:px-10"
    >
      <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-10 items-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-7"
        >
          <span className="font-pixel text-[11px] tracking-[0.25em] uppercase text-brand">
            Mother Company
          </span>
          <h2
            data-testid="company-heading"
            className="mt-4 text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tightest leading-[1.02]"
          >
            Powered by <span className="text-brand">King's Wake</span>.
          </h2>
          <p className="mt-6 text-ink/60 text-lg max-w-xl leading-relaxed">
            CoinsFlu is a product of <strong className="text-ink">King's Wake Digital Private Limited</strong> —
            a company focused on building innovative apps that simplify and
            enhance everyday life.
          </p>

          <a
            href="https://kingswake.co.in/"
            target="_blank"
            rel="noreferrer"
            data-testid="company-cta-visit"
            className="group mt-8 inline-flex items-center gap-2 bg-ink hover:bg-brand text-white px-6 py-3.5 rounded-full font-medium transition-all active:scale-95"
          >
            Visit King's Wake
            <ArrowUpRight
              size={18}
              className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
            />
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="lg:col-span-5"
        >
          <div className="relative rounded-3xl bg-surface-muted border border-black/5 p-8 overflow-hidden">
            <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-brand/10 blur-3xl" />
            <div className="font-pixel text-[10px] tracking-[0.3em] uppercase text-ink/50">
              Parent Brand
            </div>
            <div className="mt-3 text-3xl md:text-4xl font-semibold tracking-tight">
              King's Wake
            </div>
            <div className="mt-1 text-ink/50 text-sm">
              Digital Private Limited
            </div>

            <div className="mt-8 grid grid-cols-3 gap-3 text-center">
              {[
                { k: 'Apps', v: 'Multi' },
                { k: 'Founded', v: '2024' },
                { k: 'HQ', v: 'Punjab' },
              ].map((s) => (
                <div
                  key={s.k}
                  className="rounded-2xl bg-white border border-black/5 py-4"
                >
                  <div className="font-pixel text-[10px] tracking-[0.2em] uppercase text-ink/40">
                    {s.k}
                  </div>
                  <div className="mt-1 text-base font-semibold text-ink">
                    {s.v}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
